import { Injectable } from '@angular/core';
import { Observable ,  Observer } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../../../app.constants';
import * as io from 'socket.io-client';
import { IonicAngular4CacheService } from 'ionic-angular4-cache';
import { SocketService } from 'app/shared/services/socket.service';

@Injectable()
export class TimelineService {
    socket: io;
    observer: Observer<any>;
    public updateUnreadActions:any = 0;
    public validateUnreadActions:any = 0;

    constructor(private _http: HttpClient,
                private config: Configuration,
                private ionicAngular4Cache: IonicAngular4CacheService,
                private socketService:SocketService
                ) {
    }
    

    getTimeline(): Observable<Array<any>> {
        // this.socket = io.connect('http://localhost:4081');

        // this.socket.on('new-feed-item', (res) => {
        //     console.log('Data for timeline' , res);
        //     this.observer.next(res.data);
        // });

        return this.createObservable();
    }

    createObservable(): Observable<Array<any>> {
        return Observable.create((observer: Observer<any>) => {
            this.observer = observer;
        });
    }

    getAllNotifications(id:any){
        return this._http.get(`${this.config.ServerApiUrl}/notification/read?id=${id}`)
    }


    updateAction(action:any){
        return this._http.put(`${this.config.ServerApiUrl}/actionCenter/update`,action)
    }

    getAllActions(id:any,status:any,search:any,skip,limit,category?){
        var body = {
            receiverID: id,
            status: status,
            regex: search,
            category:category? category : { $regex: '', $options: 'i' },
            skip:skip,
            limit:limit
        }
        return this._http.post(`${this.config.ServerApiUrl}/actionCenter/readAll`, body)
    }



    performAction(ids, actionValue,reason) {
        return this._http.put(`${this.config.ServerApiUrl}/actionCenter/action`, {ids: ids, actionValue: actionValue, reason:reason});
    }


}
